import React from 'react';
import { Bell } from 'lucide-react';

const announcements = [
  {
    id: 1,
    title: 'Diwali Festival Sale Coming Soon!',
    date: 'October 15, 2024',
    description: 'Get ready for our biggest festival sale with up to 30% off on selected items.'
  },
  {
    id: 2,
    title: 'New Store Hours',
    date: 'Effective September 1, 2024',
    description: 'We are now open longer on weekends to serve you better!'
  },
  {
    id: 3,
    title: 'Fresh Produce Delivery',
    date: 'Every Wednesday',
    description: 'Fresh vegetables and fruits directly from local farmers.'
  }
];

export default function Announcements() {
  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-2 mb-8">
          <Bell className="text-[#568203]" size={24} />
          <h2 className="text-3xl font-bold text-gray-800">Latest Announcements</h2>
        </div>
        <div className="space-y-6">
          {announcements.map((announcement) => (
            <div key={announcement.id} className="bg-white rounded-lg shadow-md p-6">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800">{announcement.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">{announcement.date}</p>
                </div>
              </div>
              <p className="mt-4 text-gray-600">{announcement.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}